import { createIcon } from '@chakra-ui/react'

export const FacebookSocial = createIcon({
  displayName: 'FacebookSocial',
  viewBox: '0 0 12 21',
  d: 'M7.548 20.096v-9.122h3.06l.46-3.556h-3.52v-2.27c0-1.03.285-1.731 1.762-1.731l1.882-.001V.236A25.512 25.512 0 008.45.095c-2.715 0-4.573 1.657-4.573 4.7v2.622H.807v3.556h3.07v9.122h3.671z',
})
